import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/financeiro/tipo_contas${queryUrl}`)
  },
  insertNewAccountType(data) {
    return axios.post('/financeiro/tipo_contas', data)
  },
  editAccountType(data) {
    return axios.put(`/financeiro/tipo_contas/${data.id}`, data)
  },
  deleteAccountType(id) {
    return axios.delete(`/financeiro/tipo_contas/${id}`)
  },
}
